// 매치 카드/이벤트 랭킹 Preact 호스트 — DOM 진입 지점.
//
// MatchCard / EventRanking 컴포넌트는 Preact로 작성돼 있어 legacy의 vanilla
// DOM 조립 흐름과 직접 합쳐지지 않는다. 이 모듈이 mountPreact로 감싸 실제로
// HTMLElement를 돌려주는 어댑터 역할.
//
// 매치 카드는 readOnly가 아니면 점수 입력/스왑 시트로 진입해야 하지만, 두
// 시트는 legacy의 라우팅·rerender와 얽혀 있어 콜백으로 주입받는다.

import { canManageEvent } from "../auth";
import { computeEventRanking } from "../events/ranking";
import { state } from "../state";
import { MatchCard } from "../ui/components/MatchCard";
import { EventRanking } from "../ui/components/EventRanking";
import { mountPreact } from "../ui/preact-mount";

export interface MatchCardOpts {
  readOnly?: boolean;
  surfaceMap?: Map<string, string> | null;
  onScoreClick?: () => void;
  onPlayerSwap?: (pid: string) => void;
}

export function buildMatchCard(m: any, ev: any, opts: MatchCardOpts = {}): HTMLElement {
  const readOnly = !!opts.readOnly;
  const isSkipped = m.result_status === "skipped";
  const hasResult = m.result_status && m.result_status !== "empty" && !isSkipped;
  const isStaff = canManageEvent(ev);
  const isSelfSwap = !isStaff && ev.event_type === "regular";
  const swapEnabled = !readOnly && !hasResult && !isSkipped
    && (ev.status === "ready" || ev.status === "in_progress")
    && (isStaff || isSelfSwap);
  const myPid = (() => {
    if (!isSelfSwap) return null;
    const mid = state.session?.actor?.member_id;
    if (!mid) return null;
    for (const s of (m.sides || [])) {
      const found = (s.players || []).find((pl: any) => (pl.participant?.member_id || pl.member_id) === mid);
      if (found) return found.event_participant_id;
    }
    return null;
  })();
  // personal "내 모임"은 명단 전원이 외부인이라 매치 카드의 "게" 칩 의미 없음.
  const hideGuestSuffix = ev?.event_visibility === "personal";
  return mountPreact(
    <MatchCard
      m={m}
      surfaceMap={opts.surfaceMap}
      readOnly={readOnly}
      swapEnabled={swapEnabled}
      isSelfSwap={isSelfSwap}
      myPid={myPid}
      onCardClick={readOnly ? null : (opts.onScoreClick || null)}
      onPlayerSwap={opts.onPlayerSwap || null}
      hideGuestSuffix={hideGuestSuffix}
    />,
  );
}

export function buildEventRankingSection(
  ev: any,
  matches: any[],
  participants: any[],
  teams: any[],
): HTMLElement | null {
  const data = computeEventRanking(ev, matches, participants, teams);
  if (!data) return null;
  return mountPreact(<EventRanking data={data} />);
}
